import React from 'react'
import PageHeader from '../common/page-header'
import Content from './content'

const Careers = () => (
  <>
    <PageHeader title="Careers at Coast 2 Coast Refrigeration" />
    <Content />
  </>
)

export default Careers
